import { uid } from './utils';

// Regra de roteamento do nó Router. Cada regra vira uma SAÍDA (handle) do nó,
// e a aresta ligada nela grava `sourceHandle = rule.id` — assim o roteamento é
// explícito (cada saída sabe a qual regra pertence).
export interface RouterRule {
  id: string;
  label: string;
}

export function newRule(label = ''): RouterRule {
  return { id: uid('rule'), label };
}

// Normaliza `conditions` (que pode vir como string[] legado ou objeto) para regras.
export function toRules(conditions: unknown): RouterRule[] {
  if (!Array.isArray(conditions)) return [];
  return conditions.map((c, i) => {
    if (typeof c === 'string') return { id: `r${i}`, label: c };
    const obj = c as Partial<RouterRule>;
    return { id: obj.id || `r${i}`, label: obj.label ?? '' };
  });
}

// Indica se as condições já estão no formato novo (objetos com id).
export function rulesAreNormalized(conditions: unknown): boolean {
  return Array.isArray(conditions) && conditions.every((c) => c && typeof c === 'object' && 'id' in c);
}
